export default __webpack_public_path__ + "static/media/mvi.56748431.svg";